import SEO from '../components/SEO';
import './SimplePage.css';
import ParticleCanvas from '../components/ui/ParticleCanvas';

const SERVICES = [
  { name: 'WhatsApp Bot Engine',       status: 'operational', uptime: '99.98%' },
  { name: 'AI Email Assistant (Gmail)', status: 'operational', uptime: '99.96%' },
  { name: 'Shopify Integration',       status: 'operational', uptime: '99.99%' },
  { name: 'WooCommerce Webhooks',      status: 'operational', uptime: '99.96%' },
  { name: 'AI Processing Engine',      status: 'operational', uptime: '99.94%' },
  { name: 'Broadcast Delivery',        status: 'operational', uptime: '99.92%' },
  { name: 'Dashboard & API',           status: 'operational', uptime: '99.99%' },
];

const STATUS_CONFIG = {
  operational:  { label: 'Operational',   color: '#16A34A', dot: '#22C55E' },
  degraded:     { label: 'Degraded',      color: '#D97706', dot: '#F59E0B' },
  outage:       { label: 'Outage',        color: '#DC2626', dot: '#EF4444' },
  maintenance:  { label: 'Maintenance',   color: '#6366F1', dot: '#818CF8' },
};

const allOperational = SERVICES.every(s => s.status === 'operational');

export default function StatusPage() {
  return (
    <div className="simple-page">
      <SEO
        title="System Status — Zepliq Platform Uptime & Incidents"
        description="Check the real-time status of all Zepliq services: WhatsApp Bot Engine, AI Processing, Shopify Sync, Dashboard, and API. Current uptime: 99.98%."
        canonical="/status"
        noIndex={true}
      />

      <section className="simple-hero simple-hero--sm">
        <ParticleCanvas className="simple-hero__canvas" />
        <div className="simple-hero__blob simple-hero__blob--1" aria-hidden="true" />
        <div className="simple-hero__blob simple-hero__blob--2" aria-hidden="true" />
        <div className="container simple-hero__inner">
          <span className="badge badge-brand">System Status</span>
          <h1 className="display-xl simple-hero__title">
            {allOperational ? (
              <><span className="gradient-text">All systems operational.</span></>
            ) : (
              <>Some services are <span className="gradient-text">experiencing issues.</span></>
            )}
          </h1>
          <p className="text-lg simple-hero__sub">
            Real-time status of all Zepliq services. Last updated: {new Date().toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' })}.
          </p>
        </div>
      </section>

      <section className="simple-section section">
        <div className="container">

          <div className="status-overall">
            <div className={`status-overall__indicator ${allOperational ? 'status-overall__indicator--ok' : 'status-overall__indicator--warn'}`} />
            <span className="status-overall__text">
              {allOperational ? 'All systems are fully operational' : 'Some systems are experiencing issues'}
            </span>
          </div>

          <div className="status-list">
            {SERVICES.map(service => {
              const cfg = STATUS_CONFIG[service.status];
              return (
                <div key={service.name} className="status-item">
                  <div className="status-item__info">
                    <span className="status-item__dot" style={{ background: cfg.dot }} />
                    <span className="status-item__name">{service.name}</span>
                  </div>
                  <div className="status-item__right">
                    <span className="status-item__uptime">{service.uptime} uptime</span>
                    <span className="status-item__label" style={{ color: cfg.color, background: cfg.color + '18' }}>
                      {cfg.label}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="simple-divider" />

          <div className="simple-cta-box">
            <h2 className="display-md">Experiencing an issue?</h2>
            <p className="text-lg">If you notice a problem not reflected here, let our team know immediately.</p>
            <div className="simple-cta-actions">
              <a href="mailto:support@zepliq.com" className="btn btn-primary btn-lg">Report an Issue</a>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
